import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Western Port Recycled Water Scheme - Stage 1A</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
        Stage 1A will construct approximately 22 km of new recycled water pipelines to supply Pakenham South, Cora Lynn and south of Tynong areas. 
        </p>
        <p>
        This stage also includes the construction of a new pump station within the Pakenham Water Recycling Plant. Stage 1A  construction will be delivered by our industry partner Beca, Fulton Hogan, Interflow (BFHI). Construction is expected to take place from approximately mid-March 2026 to early 2027. Construction may require changed traffic conditions along the proposed pipeline installation area, including lane and local road closures. 
        </p>
        <p>
          For up-to-date project information, click{' '}
          <a
            href="https://southeastwater.com.au/westernport"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Western Port Recycled Water Scheme - Stage 1A',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800407877 ">1800 407 877</a> |{' '}
          <a
            href="mailto:engagement@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MAIL TO: ENGAGEMENT@SEW.COM.AU - Western Port Recycled Water Scheme - Stage 1A',
              });
            }}
          >
            engagement@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
